const state = {
    notifications: []
}

const mutations = {
    ADD_NOTIFICATION (state, message) {
        state.notifications.push(message)
    },
    REMOVE_NOTIFICATION (state, notification_id) {
        state.notifications.splice(notification_id, 1)
    },
}

const actions = {
    newNotification: ({commit}, message) => {
        commit('ADD_NOTIFICATION', message)
    },
    removeNotification: ({commit}, notification_id) => {
        commit('REMOVE_NOTIFICATION', notification_id)
    },
}

export default {
    state, mutations, actions
}


// WEBPACK FOOTER //
// ./src/store/notificationsStore.js